
    import { Component, Prop } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import VWidget from '@/components/VWidget.vue';
    import VueApexCharts from 'vue-apexcharts'

    @Component({
        components: { apexcharts: VueApexCharts, VWidget },
        watch: {
            dealerIds: {
                deep: true,
                handler: function () {
                    (this as any).loadData();
                }
            },
            manufacturerIds: {
                deep: true,
                handler: function () {
                    (this as any).loadData();
                }
            }
        }
    })

    export default class ChartOperation extends ListBase {
        @Prop({ type: Array, default: () => [] }) dealerIds!: number[];
        @Prop({ type: Array, default: () => [] }) manufacturerIds!: number[];
        period: Array<any> = [parseInt(new Date().toISOString().substr(0, 4))];
        month_from: any = 1;
        month: any = parseInt(new Date().toISOString().substr(5, 2));
        selectedGroup: any = null;  
        options: any = {
            chart: {
                type: 'area',
                stacked: false,
                height: 350,
                zoom: {
                    type: 'x',
                    enabled: true,
                    autoScaleYaxis: true
                },
            },
            dataLabels: {
                enabled: true,
                formatter: function (value) {
                    return new Intl.NumberFormat().format(value)
                }
            },
            stroke: {
                curve: 'smooth'
            },
            title: {
                text: 'TENDENCIAS',
                align: 'left'
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 0.7,
                    opacityTo: 0,
                    stops: [20, 90, 100]
                },
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val.toLocaleString();
                    },
                },
            },
            xaxis: {
                type: 'text',
                categories: this.monthsRange
            },
            //tooltip: {
            //    x: {
            //        format: 'dd/MM/yy HH:mm'
            //    },
            //},
            legend: {
                position: 'top',
                horizontalAlign: 'center',
                floating: true,
                offsetY: -15
            }
        };

        get periods() {
            return this.gCommonList('years');
        }

        get months() {
            let list = this.gCommonList('months');
            list.forEach(m => {
                m['field'] = 'month_' + m.id;
            });
            return list;
        }

        get dealer() {
            return this.$store.state.app.dealer;
        }

        get manufacturer() {
            return this.$store.state.app.manufacturer;
        }

        get figures() {
            return this.$store.state.dashboard.figures;
        }

        get series() {
            if (this.figures[this.selectedGroup] == undefined) return [];
            return this.figures[this.selectedGroup];
        }

        get maxYear() {
            let maxYear = 0;
            this.period.forEach(year => {
                if (year > maxYear) maxYear = year;
            });
            return maxYear;
        }

        get totals() {
            let list = [];
            this.figures.forEach(items => {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].year == this.maxYear) {
                        let item = items[i];
                        let amount = (item.data.length > 0 && item.data[item.last_month - 1] != null ? item.data[item.last_month - 1] : 0);
                        let amount_ant = (item.data.length > 1 && item.data[item.last_month - 2] != null ? item.data[item.last_month - 2] : 0);
                        let increase = 0;
                        if (amount > amount_ant)
                            increase = (amount > 0 ? parseFloat((100 - (amount_ant * 100 / amount)).toFixed(1)) : 0);
                        else
                            increase = (amount_ant > 0 ? parseFloat((100 - (amount * 100 / amount_ant)).toFixed(1)) : 0) * -1;
                        list.push({
                            name: item.name,
                            amount: amount,
                            increase: increase
                        });
                    }
                }
            });
            return list;
        }

        get loading() {
            return this.$store.state.dashboard.loading;
        }

        get monthsRange() {
            let list = this.gCommonList('months');
            let months = [];
            list.forEach(item => {
                months.push(item.name.substr(0,3));
            });

            return months;
        }

        setPeriod() {
            this.$store.commit('dashboard/setPeriod', this.maxYear);
        }

        changeGroup() {
        }

        async loadData() {
            if (this.dealerIds.length === 0 || this.manufacturerIds.length === 0) {
                this.$store.commit('dashboard/setFigures', []);
                return;
            }
            this.setPeriod();
            await this.$store.dispatch({
                type: 'dashboard/getDashFigures',
                data: {
                    years: this.period,
                    manufacturer_ids: this.manufacturerIds,
                    dealer_ids: this.dealerIds
                }
            });          
        }

        mounted() { 
            this.loadData();
        }
    }
